import {DailyReportAlarmSummary} from "../types/DailyReportAlarmSummary.types";
import {formatOverviewAlarmCount} from "../../PerformanceAnalysis/performanceAnalysisUtils";

export type DailyReportAlarmCategory =
    | "POWER_STATION_COMMUNICATION"
    | "CRITICAL"
    | "EQUIPMENT_COMMUNICATION"
    | "NON_CRITICAL";

export interface DailyReportAlarmCategoryItem {
    category: DailyReportAlarmCategory;
    label: string;
    count: number;
    displayCount: string;
}

export interface DailyReportAlarmCellModel {
    visible: DailyReportAlarmCategoryItem[];
    grouped: DailyReportAlarmCategoryItem[];
}

// Ordem de exibição definida no card SGD-3830.
const CATEGORY_ORDER: Array<{category: DailyReportAlarmCategory; label: string; key: keyof DailyReportAlarmSummary}> = [
    {category: "POWER_STATION_COMMUNICATION", label: "Comunicação usina", key: "powerStationNoCommunication"},
    {category: "CRITICAL", label: "Críticos", key: "critical"},
    {category: "EQUIPMENT_COMMUNICATION", label: "Comunicação equip.", key: "equipmentNoCommunication"},
    {category: "NON_CRITICAL", label: "Não Críticos", key: "nonCritical"},
];

// Com as quatro categorias presentes, estas passam a ser exibidas no indicador agrupado.
const GROUPABLE_CATEGORIES: DailyReportAlarmCategory[] = ["EQUIPMENT_COMMUNICATION", "NON_CRITICAL"];

// Mesma validação do payload de alarmes da Visão Geral (PerformanceAnalysisReducer, SGD-3764).
function isRecord(value: unknown): value is Record<string, unknown> {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}

function isAlarmCount(value: unknown): value is number {
    return typeof value === "number" && Number.isInteger(value) && value >= 0;
}

export function isDailyReportAlarmSummary(value: unknown): value is DailyReportAlarmSummary {
    return isRecord(value) && CATEGORY_ORDER.every(({key}) => isAlarmCount(value[key]));
}

export function buildDailyReportAlarmCellModel(summary: DailyReportAlarmSummary | null | undefined): DailyReportAlarmCellModel {
    if (!summary) return {visible: [], grouped: []};

    const present = CATEGORY_ORDER
        .map(({category, label, key}) => ({
            category,
            label,
            count: summary[key],
            displayCount: formatOverviewAlarmCount(summary[key]),
        }))
        .filter((item): item is DailyReportAlarmCategoryItem => item.displayCount != null);

    if (present.length < CATEGORY_ORDER.length) {
        return {visible: present, grouped: []};
    }

    return {
        visible: present.filter((item) => !GROUPABLE_CATEGORIES.includes(item.category)),
        grouped: present.filter((item) => GROUPABLE_CATEGORIES.includes(item.category)),
    };
}
